<template>
  <div>
    <el-dialog title="试卷信息预览" :visible.sync="dialogVisible" width="900px" custom-class="no-padding full-height" :close-on-click-modal="false">
      <div class="paper-content" v-infinite-scroll="getQuestions" :infinite-scroll-distance="100" :infinite-scroll-disabled="finished || loading" infinite-scroll-immediate="false">
        <div class="inner-content">
          <div class="top-info" id="top_info">
            <div class="fx-1">
              <ul class="paper-details">
                <li class="block">
                  <div class="key">试卷名称：</div>
                  <div class="value" style="color: #04ADC0;">
                    <!-- <el-tag v-if="details.sourceId" type="primary" >引用</el-tag> -->
                    {{ details.name }}
                  </div>
                </li>
                <li v-if="details.subjectCatalogueName || details.testPaperGroupName">
                  <div class="key">课程/归属：</div>
                  <div class="value">{{ details.subjectCatalogueName || details.testPaperGroupName }}</div>
                </li>
                <!-- <li>
                  <div class="key">试卷类型：</div>
                  <div class="value">{{ details.type | paperType }}</div>
                </li> -->
                <li>
                  <div class="key">试卷级别：</div>
                  <div class="value">{{ details.level | paperLevel }}试卷</div>
                </li>
                <li>
                  <div class="key"></div>
                  <div class="value">
                    <span>试卷共<span style="margin: 0 5px;color: #04ADC0;">{{ details.questionNumber}}</span>道题，</span>
                    <span>
                      整体难度<el-rate style="display:inline-block;vertical-align: middle;margin-left:5px" v-model="details.difficulty" disabled text-color="#ff9900" disabled-void-color="#ccc"></el-rate>
                    </span>
                  </div>
                </li>
                <li v-if="details.mode">
                  <div class="key">随机题量：</div>
                  <div class="value">{{ details.examQuestionCount }}</div>
                </li>
                <li v-if="details.mode == 1">
                  <div class="key">随机难度系数：</div>
                  <div class="value">{{ details.difficultyCoefficient }}</div>
                </li>
                <li v-if="details.mode == 2">
                  <div class="key">随机题型：</div>
                  <div class="value">
                    <span>单选题({{ details.radioQuestionProportion }})&nbsp;&nbsp;</span>
                    <span>多选题({{ details.mcQuestionProportion }})&nbsp;&nbsp;</span>
                    <span>判断题({{ details.torFQuestionProportion }})&nbsp;&nbsp;</span>
                  </div>
                </li>
                <li v-if="details.label">
                  <div class="key">标签：</div>
                  <div class="value">{{ details.label }}</div>
                </li>
              </ul>
              <div v-if="details.description">
                <p class="color-999">{{ details.description }}</p>
              </div>
              <div class="question-details" :class="{'flex':details.questionTypeNumber && details.questionTypeNumber.length>3}" v-if="details.questionTypeNumber && details.questionTypeNumber.length>0">
                <div v-for="item in details.questionTypeNumber" :key="item.questionTypeTag" class="items" @click.stop="scrollPosition('tag_'+item.questionTypeTag,'start')">
                  <p>{{ item.questionTypeTag }}<b style="margin: 0 2px;font-weight: normal;">{{ item.number }}</b>题（<template v-for="s in item.list"><span :key="s.difficulty" v-if="s.count">{{ s.difficulty | capitalNumber }}星:{{
                    s.count }}</span></template>）</p>
                </div>
              </div>
            </div>
            <div class="code" v-if="details.qrUrl">
              <qr-code :text="details.qrUrl" :size="180" :logo="$root.tenantInfo.logoUrl"></qr-code>
              <p class="mt-5 text-center">试卷资源码</p>
            </div>
          </div>
          <div class="question-list">
            <div class="tag-item" v-for="(item,order) in dataList" :key="item.id" :id="'tag_'+item.tagName">
              <h4 v-if="item.tagName"><span>{{ func.capitalNumber(order+1) }}、{{ item.tagName }}（共<span style="margin: 0 2px;">{{item.children.length}}</span>题）</span></h4>
              <single-question :data="data.question" v-for="(data, index) in item.children" :key="index" :index="index+1" deleteMode="custom" @callback="editPaperQuestion"></single-question>
            </div>
          </div>
        </div>
      </div>
      <el-button type="info" circle class="to-top" @click.stop="scrollPosition('top_info')"><span class="iconfont icon-fanhuidingbu font-18"></span></el-button>
      <div slot="footer" class="dialog-footer">
        <slot name="btns" v-if="slotBtns"></slot>
        <template v-else>
          <el-button @click="dialogVisible = false">关闭</el-button>
          <el-button type="primary" @click="download" v-if="isDownload">导出题目</el-button>
          <el-button type="primary" @click="dialogVisible = false" v-else>确定</el-button>
        </template>
      </div>
    </el-dialog>
    <question-edit-model :data="question" v-model="questionVisible" @callback="editPaperQuestion" :type="type"></question-edit-model>
  </div>
</template>
<script>
export default {
  components: {
  },
  props: {
    value: "",
    id: "",
    isDownload: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    type: "",
    update: null,
    slotBtns: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      loading: false,
      finished: false,
      dialogVisible: false,
      pagination: {
        pageIndex: 1,
        pageSize: 20,
        dataCount: 0,
      },
      details: {},
      dataList: [],
      query: {},
      questionVisible: false,
      question: {},
    }
  },
  watch: {
    value(val) {
      this.dialogVisible = this.value;
    },
    dialogVisible(val) {
      if (val) {
        this.updateData();
      } else {
        this.$emit('callback', 'hide');
      }
    },
    update() {
      if (this.dialogVisible) {
        this.updateData();
      }
    },
  },
  created() {

  },
  mounted() {

  },
  methods: {
    updateData() {
      this.finished = false;
      this.pagination.pageIndex = 1;
      this.dataList = [];
      this.getDetails();
      this.getQuestions();
    },
    getDetails() {
      let params = {
        id: this.id,
      }
      this.loading = true;
      this.https("get", "/api/TestPaper/GetTestPaper", params).then(res => {
        this.loading = false;
        if (res.success) {
          this.details = res.response || {};
          this.details.qrUrl = `${this.envConfig.mobile}#/resource/paper-details?tenantCode=${this.$root.tenantInfo.code}&id=${this.details.id}`;
          try {
            this.details.questionTypeNumber = JSON.parse(this.details.questionTypeNumber);
          } catch (error) {
            this.details.questionTypeNumber = [];
          }
          this.details.questionTypeNumber.map(item => {
            item.list = [];
            for (let key in item.difficulty) {
              let difficulty = key.split("star")[1];
              let temp = {
                difficulty,
                count: item.difficulty[key],
              }
              item.list.push(temp)
            }
          })
        } else {
          this.func.message("error", res.msg);
        }
      }).catch(() => {
        this.loading = false;
      })
    },
    getQuestions() {
      let params = Object.assign({ testPaperId: this.id }, this.pagination);
      delete params.dataCount;
      this.loading = true;
      this.https("get", "/api/TestPaper/GetTestPaperQuestions", params).then(res => {
        if (this.pagination.pageIndex <= 1) {
          this.dataList = [];
        }
        this.loading = false;
        let datas = res.response ? res.response.data || res.response.children || [] : [];
        datas.map(item => {
          item.id = item.id || item.tagId;
          let index = this.dataList.findIndex(s => s.id == item.id);
          if (index < 0) {
            this.dataList.push(item);
          }
        })
        let pagination = res.response.getPages || {};
        if (pagination.pageIndex * pagination.pageSize >= pagination.dataCount) {
          this.finished = true;
        } else {
          this.pagination.pageIndex = this.pagination.pageIndex + 1;
        }
        if (!pagination.dataCount || datas.length == 0) {
          this.finished = true;
        }
      }).catch(res => {
        this.loading = false;
        this.finished = true;
        this.dataList = [];
      })
    },
    download() {
      let params = {
        fileName: this.details.name,
        body: [],
        questionIds: [],
        testPaperId: this.id,
      }
      this.$root.fullLoading("正在导出数据，请耐心等待...");
      this.httpDownload("post", "/api/Analysis/QuestionToDoc", params).then(res => {
        this.$root.closeLoading();
        this.func.message("success", "导出成功");
        this.func.fileDownload(res, `${params.fileName}.docx`);
      }).catch(res => {
        this.$root.closeLoading();
      })
    },
    editPaperQuestion(type, data) {
      if (type == "edit") {
        this.question = data;
        this.questionVisible = true;
      } else if (type == "hide") {
        this.questionVisible = false;
      } else if (type == "delete") {
        this.deletePaperQuestion(data);
      } else if (type == "success") {
        this.getQuestions();
        this.questionVisible = false;
      } else {
        this.questionVisible = false;
      }
    },
    deletePaperQuestion(data) {
      this.$confirm('是否确定从试卷中删除该题目？', '操作提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          testPaperId: this.id,
          questionId: data.id,
        }
        this.https("delete", "/api/TestPaper/DelTestPaperQuestion", params).then(res => {
          if (res.success) {
            this.getDetails();
            this.getQuestions();
          } else {
            this.func.message("error", res.msg);
          }
        })
      })
    },
    editPaper() {
      this.$emit('callback', 'edit');
    },
    scrollPosition(id, position = 'center') {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: position });
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.paper-content {
  height: 100%;
  padding: 25px 40px 10px;
  overflow: auto;
  position: relative;

  .inner-content {
    height: 100%;
    position: relative;
    .top-info {
      display: flex;
      justify-content: space-between;
    }
    .code {
      flex-shrink: 0;
      position: relative;
      right: 0px;
      top: 0px;
      text-align: center;
      z-index: 1;
      margin-left: 20px;
    }
  }

  .paper-details {
    position: relative;
    padding: 1px 0;
    display: flex;
    flex-wrap: wrap;

    li {
      display: flex;
      font-size: 15px;
      margin: 6px 0;
      width: 50%;

      &.block {
        width: 100%;
      }
    }
  }

  .question-details {
    // min-height: 75px;
    position: relative;
    margin-top: 5px;
    & > h4 {
      display: flex;
      flex-wrap: wrap;
    }
    .block {
      display: block !important;
      width: 100% !important;
    }
    &.flex {
      display: flex;
      flex-wrap: wrap;
      .items {
        width: 50%;
      }
    }
    .items {
      margin: 8px 0 0;
      color: #777;

      p {
        line-height: 1.3;

        & > span::after {
          content: ",";
        }

        & > span:last-child::after {
          content: none;
        }
      }
    }
  }

  .question-list {
    // border: 1px solid #eee;
    min-height: 400px;
    padding: 1px 0;
    margin-top: 15px;
    position: relative;
    .tag-item {
      position: relative;
      & > h4 {
        margin-bottom: 10px;
        font-size: 15px;
      }
    }
    & > .question:last-child {
      margin-bottom: 0px;
    }
    .icon {
      display: flex;
      align-items: center;
      & > small {
        margin-left: 2px;
      }
    }
  }
}
.to-top {
  position: absolute;
  right: 15px;
  bottom: 80px;
  z-index: 1;
  padding: 8px;
  background-color: rgba(0, 0, 0, 0.2);
  border: none !important;
  &:hover {
    background-color: rgba(0, 0, 0, 0.3);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/PaperView.vue